import { SOCIAL_ICONS } from "data/staticData";
import { Zap, Globe } from "lucide-react"
// Swiper Imports
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';

// Swiper Styles
import 'swiper/css';
import 'swiper/css/pagination';
import styles from '../../styles/FeaturedWorks.module.css';

export const roleOptions = [
  { value: "1", label: "Director" },
  { value: "2", label: "Camera Operator" },
  { value: "3", label: "Audio Engineer" },
  { value: "4", label: "Lighting Technician" },
  { value: "5", label: "Video Editor" },
  { value: "6", label: "Stream Engineer" },
  { value: "7", label: "Production Manager" },
  { value: "8", label: "Graphics Designer" },
  { value: "9", label: "Videographer" },
  { value: "10", label: "Photographers" },
];

export const skillOptions = [
  { value: "13", label: "Director" },
  { value: "12", label: "Livestream Audio" },
  { value: "2", label: "Video Event" },
  { value: "3", label: "Video Music" },
  { value: "4", label: "Video Lifestyle" },
  { value: "5", label: "Photo Portrait" },
  { value: "6", label: "Photo Product" },
  { value: "7", label: "Photo Event" },
  { value: "8", label: "Photo Lifestyle" },
  { value: "9", label: "Audio Engineer" },
  { value: "10", label: "Creative Director" },
  { value: "11", label: "Livestream Director" },
  { value: "1", label: "Video Commercial" },
  { value: "14", label: "Video Weddings" },
  { value: "15", label: "Photo Weddings" },
  { value: "16", label: "Portrait Photo" },
  { value: "17", label: "Cinematographer" },
];

const ProfileCard = ({ data }) => {
  console.log("ProfileCard Data:", data);
  const role = roleOptions.find(option => option.value === data?.role)?.label || "";

  const skills = data?.skills?.map(skillId => skillOptions.find(option => option.value === skillId)?.label).join(", ");

  const profileImage = data?.profilePreview || "/images/Group.png";

  const cleanBio = (value) => {
    return value.replace(/[ ]{3,}/g, "  ").replace(/\n{3,}/g, "\n\n")
  }

  return (
    <div className="flex flex-col gap-4 flex-grow overflow-y-scroll [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
      <div className="flex items-center gap-3">
        <div className="w-12 h-12 rounded-full bg-gray-200 flex items-center justify-center shrink-0">
          <img
              src={profileImage}
              alt="Profile Image"
              fill
              sizes="48px"
              priority
              className="object-contain p-1.0"
            />
        </div>
        <div className="">
          <p className="font-semibold">
            {data?.firstName !== "" ? data.firstName : "John"} {data?.lastName !== "" ? data.lastName : "Doe"}
          </p>
          <p className="text-sm text-gray-500">{data?.location?.address || "New York, USA"}</p>
        </div>

        {/* <button
          type="button"
          className="ml-auto flex items-center gap-2 px-3 py-2 bg-black text-white rounded-full text-sm w-2/5"
        >
          <Zap className="w-4 h-4 fill-white" />
          View Details
        </button> */}
      </div>

      {
        (data?.links?.length > 0) &&
        <div className="flex gap-2 flex-wrap">
          {data?.links.map((link) => (
            <SocMedTab
              key={link.id}
              socMedItem={link}
            />
          ))}
        </div>
      }

      {
        (Object.keys(data).length !== 0) &&
        <>
          <div className="flex flex-col gap-6">
            {/* Row 1: Email and Role */}

            {/* Row 2: Hourly Rate, Experience, and Working Distance */}
            <div className="flex gap-6 items-center w-full">
              {/* Hourly Rate - shrink-0 makes it only as wide as its content */}
              {data?.hourlyRate !== "" && (
                <div className="flex flex-col gap-[1px] shrink-0">
                  <p className="text-base font-medium text-black">${data?.hourlyRate}</p>
                  <p className="text-xs text-grey-4">/Hour</p>
                </div>
              )}

              {/* Experience (YOE) - shrink-0 makes it only as wide as its content */}
              {data?.yoe !== "" && (
                <div className="flex flex-col gap-[1px] shrink-0">
                  <p className="text-base font-medium text-black">{data?.yoe}</p>
                  <p className="text-xs text-grey-4">Experience</p>
                </div>
              )}

              {/* Working Distance - flex-1 makes it take up all the remaining available space */}
              {data?.workingDistance && (
                <div className="flex flex-col gap-[1px] flex-1 min-w-0">
                  <p className="text-base font-medium text-black truncate" title={data.workingDistance}>
                    {data.workingDistance}
                  </p>
                  <p className="text-xs text-grey-4 whitespace-nowrap">Working Distance</p>
                </div>
              )}
            </div>
            <div className="flex gap-6 items-center">
              {/* Email */}
              {data?.email && (
                <div className="flex flex-col gap-[1px] flex-1">
                  <p className="text-base font-medium text-black">{data.email}</p>
                  <p className="text-xs text-grey-4">Email</p>
                </div>
              )}

              {/* Role */}
              {role !== "" && (
                <div className="flex flex-col gap-[1px] flex-1">
                  <p className="text-base font-medium text-black">{role}</p>
                  <p className="text-xs text-grey-4">Role</p>
                </div>
              )}
            </div>
          </div>

          {/* Display Skills */}
          {skills.length !== 0  && (
            <div className="flex gap-6">
              <div className="flex flex-col gap-[1px]">
                <p className="text-base font-medium text-black">{skills}</p>
                <p className="text-xs text-grey-4">Skills</p>
              </div>
            </div>
          )}

          {/* Bio */}
          {data?.bio && (
            <div className="flex gap-6">
              <div className="flex flex-col gap-[1px]">
                <p className="text-base font-medium text-black whitespace-pre-wrap">{cleanBio(data.bio)}</p>

                <p className="text-xs text-grey-4">Bio</p>
              </div>
            </div>
          )}

          {/* Equipments */}
          {data?.equipments && data.equipments.length > 0 && (
            <div className="flex gap-6">
              <div className="flex flex-col gap-[1px]">
                <p className="text-base font-medium text-black">{data.equipmentNames.join(", ")}</p>
                <p className="text-xs text-grey-4">Equipments</p>
              </div>
            </div>
          )}
        </>
      }


      <p className="text-gray-600 text-sm">
        Let&apos;s complete your profile to help you discover the best opportunities.
      </p>

      <>
        {/* {data?.featuredWork.length > 0 && (
          <div className="flex gap-4 flex-wrap">
            {data?.featuredWork?.map((work, index) => (
              <div
                key={index}
                className="w-[230px] h-[172px] py-4 px-3 flex items-end bg-center bg-cover bg-no-repeat"
                style={{
                  backgroundImage: work?.image
                    ? `url(${work.image})`
                    : "none",
                  backgroundColor: work?.image ? "transparent" : "#E5E7EB", // grey fallback
                }}
              >
                <span className="text-sm font-medium text-white drop-shadow">
                  {work.title}
                </span>
              </div>
            ))}
          </div>
        )} */}
        {data?.featuredWork?.length > 0 && (
          <div className="space-y-3">
            <div className="grid grid-cols-1 gap-4">
              {data.featuredWork.map((work, index) => {
                const images = work.previews?.length ? work.previews : work.image ? [work.image] : [];

                return (
                  <div
                    key={index}
                    className="w-full aspect-video relative rounded-xl overflow-hidden bg-zinc-900 group"
                  >
                    {images.length > 0 ? (
                      <Swiper
                        modules={[Pagination]}
                        pagination={{ clickable: true }}
                        className={`${styles.featuredSwiper} w-full h-full`}
                      >
                        {images.map((src, idx) => (
                          <SwiperSlide key={idx}>
                            <img
                              src={src}
                              alt={`${work.title} ${idx}`}
                              className="w-full h-full object-cover transition-transform group-hover:scale-105 duration-500"
                            />
                          </SwiperSlide>
                        ))}
                      </Swiper>
                    ) : (
                      <div className="w-full h-full flex items-center justify-center">
                        <Globe className="w-8 h-8 text-white/10" />
                      </div>
                    )}
                    <span className="absolute bottom-4 left-4 z-20 text-sm font-medium text-white pointer-events-none">
                      {work.title}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </>

      <div className="absolute bottom-0 left-0 w-full h-[70px] bg-gradient-to-t from-black/40 to-transparent rounded-b-2xl pointer-events-none" />
    </div>
  )
}

export default ProfileCard;



const SocMedTab = ({ socMedItem }) => {
  const platform = SOCIAL_ICONS.find((p) => p.id === socMedItem.platform);

  return (
    <div className="flex gap-2 px-3 py-1 border border-accent rounded-lg">
      {platform?.src ? (
        <img src={platform.src} alt={platform.label} className="w-5 h-5" />
      ) : platform?.icon ? (
        <platform.icon className="w-5 h-5 text-[#9C8662]" />
      ) : (
        <Globe className="w-5 h-5 text-[#9C8662]" />
      )}
      <span className="text-grey-primary text-sm">
        {socMedItem.name}
      </span>
    </div>
  )
}
